import client from './client'

export const BODY = Object.freeze({ SUN: 'SUN', MOON: 'MOON', EARTH: 'EARTH' })

export default {
    fetchTwilight({ lat, lon, timezoneSlug, date1, date2 }) {
        return client.post('/astra/sun/twilight/', { lat, lon, timezone_slug: timezoneSlug, date1, date2 })
    },
    fetchSunRiseSet({ lat, lon, timezoneSlug, date1, date2 }) {
        return client.post('/astra/sun/rise-set/', { lat, lon, timezone_slug: timezoneSlug, date1, date2 })
    },
    fetchSeasons({ lat, lon, timezoneSlug, date1, date2 }) {
        return client.post('/astra/sun/seasons/', { lat, lon, timezone_slug: timezoneSlug, date1, date2 })
    },
    fetchMoonRiseSet({ lat, lon, timezoneSlug, date1, date2 }) {
        return client.post('/astra/moon/rise-set/', { lat, lon, timezone_slug: timezoneSlug, date1, date2 })
    },
    fetchMoonPhases({ lat, lon, timezoneSlug, date1, date2 }) {
        return client.post('/astra/moon/phases/', { lat, lon, timezone_slug: timezoneSlug, date1, date2 })
    },
    fetchMoonIllumination({ lat, lon, timezoneSlug, date1, date2 }) {
        return client.post('/astra/moon/illumination/', { lat, lon, timezone_slug: timezoneSlug, date1, date2 })
    },
    fetchAltitudeAzimuth({ lat, lon, timezoneSlug, date1, body }) {
        return client.post('/astra/body/altitude-azimuth/', { lat, lon, timezone_slug: timezoneSlug, date1, body })
    },
    fetchBodyDistance({ lat, lon, timezoneSlug, date1, start, end }) {
        return client.post('/astra/body/distance/', { lat, lon, timezone_slug: timezoneSlug, date1, start, end })
    },
    fetchPlanetsSummary({ lat, lon, timezoneSlug, date1 }) {
        return client.post('/astra/planet/summary/', { lat, lon, timezone_slug: timezoneSlug, date1 })
    },
    fetchBodyRiseSet({ lat, lon, timezoneSlug, date1, date2, body }) {
        return client.post('/astra/body/rise-set/', { lat, lon, timezone_slug: timezoneSlug, date1, date2, body })
    },
    fetchJournal({ lat, lon, timezoneSlug, date1 }) {
        return client.post('/astra/journal/', { lat, lon, timezone_slug: timezoneSlug, date1 })
    },
    fetchTides({ lat, lon, timezoneSlug, date1 }) {
        return client.post('/astra/tides/', { lat, lon, timezone_slug: timezoneSlug, date1 })
    },
    fetchSolunar({ lat, lon, timezoneSlug, date1, date2 }) {
        return client.post('/astra/moon/solunar/', { lat, lon, timezone_slug: timezoneSlug, date1, date2 })
    },
}
